import ChatDivide from "../../assets/img/subject_underline_shine_effect.png";
import React, {memo} from "react";
import DivideSparkImg from "./DivideSparkImg";
import {makeStyles} from "@material-ui/core/styles";

const useStyles = makeStyles({
    root: {
        width: '35%',
        position: 'relative',
        margin: '0 auto',
        zIndex: 5
    },
    header: {
        fontSize: '1.2vw',
        fontFamily: 'DINPro-Bold',
        height: 'auto'
    },
    title: {
        padding: '10px 20px',
        lineHeight: '3.4vw'
    },
    closeIcon: {
        padding: '0.2vw 0.5vw',
        cursor: "pointer",
        lineHeight: '3.4vw'
    },
    body: {
        margin: '2.5vw 1.5vw',
        height: '24vh',
        overflowY: 'auto'
    },
    termsItem: {
        margin: '0.8vw 1.1vw',
        fontSize: '1.1vw',
        textAlign: 'justify'
    },
    divideSpark: {
        height: 10
    }
})

const TERMS = [
    "By participating in this virtual photo booth at the Singapore Business Awards 2020, " +
    "you hereby consent, accept and agree that your image may be captured (in photographs or video) " +
    "and may be used for marketing purposes related to this event.",

    "By clicking on the ‘Start’ button, you hereby agree to observe Safe Management Measures " +
    "as required by the Singapore laws and regulations."
];

const TermsAndConditionsDialog = ({onStart, onClose}) => {
    
    const classes = useStyles()
    
    return (<div className={classes.root + " coverup photobooth-cover termbox"}>
        <div className={classes.header}>
            <span className={classes.title}>Terms &amp; Conditions</span>
        </div>
        <div className={classes.body + " termsTextBox custom-scrollbar"}>
            {TERMS.map((text, index) => (<div key={index} className={classes.termsItem}>{text}</div>))}
        </div>
        <DivideSparkImg className={classes.divideSpark}/>
        <div><button className="startBtn" onClick={onStart}>Start</button></div>
    </div>);
}

export default memo(TermsAndConditionsDialog)